import * as React from 'react';

import { useDiagram } from 'src/containers/ProjectDiagram/hooks/useDiagramValue';
import { commitDiagramModel } from 'src/containers/ProjectDiagram/utils/commitDiagramModel';
import { updateMappingSetClassType } from 'src/containers/ProjectDiagram/utils/mapping/updateMappingSetClassType';

export const useUpdateMappingSetClassType = (key?: string) => {
  const diagram = useDiagram();

  return React.useCallback(
    (setClassType: boolean) => {
      if (!diagram || !key) {
        return;
      }
      commitDiagramModel(
        diagram,
        updateMappingSetClassType({
          key,
          setClassType,
        })
      );
    },
    [diagram, key]
  );
};
